import React from 'react';
import { Box, Typography } from '@mui/material';
import FacturaCard from '../components/facturaCard';
import { useNavigate } from 'react-router-dom';

const FacturasPorSuministro = ({ impagas, id }) => {

  const navigate = useNavigate()
const handlePay = (factura) => {
  navigate(`/missuministros/facturaspago`, {    
    state: {
      facturas: impagas,  
      seleccionInicial: factura
    }
  });
};
  return (
    <Box mt={3}>
      {impagas.length === 0 ? (
        <Typography>No hay facturas impagas</Typography>
      ) : (
        impagas.map((factura, index) => (
          <FacturaCard key={index} factura={factura} onPay={handlePay} />
        ))
      )}
    </Box>
  );
};

export default FacturasPorSuministro;
